/// <reference path="irep.js"/>

/*
resizeDebounce will delay the resize event by a given time to reduce the number of function calls the default resize event calls.
Requires Jquery

Implementation:

$(window).resizeDebounce({
    timeoutDelay: 200,
    runOnStart: false,
    onResizeEnd: someFunc()
});

timeoutDelay: time in miliseconds to delay after resize stops
runOnStart: Boolean, defines weather or not onResizeEnd will fire as soon as the page loads
onResizeEnd: Function to run after resize ends.
*/
(function ($) {
    "use strict";

    $.resizeDebounce = function (el, options) {
        var that = this;
        
        that.el = el;
        that.baseTime = new Date();
        that.timeout = false;

        that.init = function () {
            that.options = $.extend({}, $.resizeDebounce.defaults, options);
            if (that.options.runOnStart) that.options.onResizeEnd();
            
            $(that.el).resize(function () {
                that.baseTime = new Date();
                if (that.timeout === false) {
                    that.timeout = true;
                    setTimeout(that.debounce, that.options.timeoutDelay);
                }
            });
        };
        
        that.debounce = function () {
            if (new Date() - that.baseTime < that.options.timeoutDelay) {
                setTimeout(that.debounce, that.options.timeoutDelay);
            } else {
                that.timeout = false;
                that.options.onResizeEnd();
            }
        };

        that.init();
    };

    $.resizeDebounce.defaults = {
        timeoutDelay: 100,
        runOnStart: false,
        onResizeEnd: function () { }
    };

    $.fn.resizeDebounce = function (options) {
        return this.each(function () {
            (new $.resizeDebounce(this, options));
        });
    };

})(jQuery);
